/** Single source of truth for all Braze banner placement IDs in this app. */

export const HOME_SCREEN_BANNER_WEB = "home_screen_banner_web";
export const HOME_SCREEN_BANNER_MWEB = "home_screen_banner_mweb";
export const HERO_ALTERNATE_BANNER_WEB = "hero_alternate_banner_web";

export const REWARDS_BANNER_WEB = "rewards_banner_web";
export const REWARDS_PROTEIN_POINTS_WEB = "rewards_protein_points_web";
export const HOME_PENCIL_BANNER_WEB = "home_pencil_banner_web";

export const REWARDS_TOP_BANNER_MWEB = "rewards_top_banner_mweb";
export const REWARDS_MID_BANNER_MWEB = "rewards_mid_banner_mweb";
export const REWARDS_PROTEIN_POINTS_BANNER_MWEB =
  "rewards_protein_points_banner_mweb";
export const TOP_BANNER_MWEB = "top_banner_mweb";
export const RECENT_ORDERS_TAB_BANNER_MWEB = "recent_order_tab_banner_mweb";
export const STICKY_FOOTER_BANNER_MWEB = "sticky_footer_banner_mweb";
export const FOOTER_BANNER_WEB = "footer_banner_web";
export const CATEGORY_BANNER_MWEB = "category_banner_mweb";
export const MENU_HEADER_BANNER_MWEB = "menu_header_banner_mweb";
export const MENU_DROPDOWN_BANNER_WEB = "menu_dropdown_banner_web";

export const PROMO_LANDING_BANNER_WEB = "promo_landing_banner_web";
export const PROMO_LANDING_BANNER_MWEB = "promo_landing_banner_mweb";

/** Desktop — one batched fetch per session. */
export const DESKTOP_BRAZE_PLACEMENT_IDS = [
  REWARDS_BANNER_WEB,
  REWARDS_PROTEIN_POINTS_WEB,
  HOME_PENCIL_BANNER_WEB,
  HOME_SCREEN_BANNER_WEB,
  PROMO_LANDING_BANNER_WEB,
  HERO_ALTERNATE_BANNER_WEB,
  FOOTER_BANNER_WEB,
  MENU_DROPDOWN_BANNER_WEB,
] as const;

/** Mobile — one batched fetch per session. */
export const MOBILE_BRAZE_PLACEMENT_IDS = [
  REWARDS_TOP_BANNER_MWEB,
  REWARDS_MID_BANNER_MWEB,
  REWARDS_PROTEIN_POINTS_BANNER_MWEB,
  TOP_BANNER_MWEB,
  RECENT_ORDERS_TAB_BANNER_MWEB,
  STICKY_FOOTER_BANNER_MWEB,
  HOME_SCREEN_BANNER_MWEB,
  CATEGORY_BANNER_MWEB,
  MENU_HEADER_BANNER_MWEB,
  PROMO_LANDING_BANNER_MWEB,
] as const;

export const ALL_BRAZE_PLACEMENT_IDS = [
  ...DESKTOP_BRAZE_PLACEMENT_IDS,
  ...MOBILE_BRAZE_PLACEMENT_IDS,
] as const;

export type BrazePlacementId = (typeof ALL_BRAZE_PLACEMENT_IDS)[number];
